// extracted by mini-css-extract-plugin
module.exports = {"PredictWeightStatus":"PredictWeightStatus_PredictWeightStatus__qHV5r","Terms":"PredictWeightStatus_Terms__wQlzF","ExtraInfo":"PredictWeightStatus_ExtraInfo__2ywkf"};